import { render, staticRenderFns } from "./New Layout.vue?vue&type=template&id=3dc37f4c&scoped=true&"
var script = {}
import style0 from "./New Layout.vue?vue&type=style&index=0&id=3dc37f4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc37f4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
